const namespace = 'calendar';
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getBoxHeight, getBoxColor, getBoxBackColor } from '@/utils/style';
import { AppComponentsVisibility } from '@/plugins/vuetify/themes/types';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';

@Component({
    name: 'SingleActivityBox',
    components: {},
})
export default class SingleActivityBox extends Vue {
    @Prop() public eventProp!: ICalendarData;
    @Getter('locationWidth', { namespace }) protected locationWidth!: number;
    @Getter('boxWidth', { namespace }) protected boxWidth!: number;
    @Getter('cellHeight', { namespace }) protected cellHeight!: number;
    @Getter('isMobile', { namespace }) protected isMobile!: number;
    @Getter('componentsVisibility', { namespace: 'configuration' })
    protected componentsVisibility!: AppComponentsVisibility;
    protected aspectRatio = 1;
    protected elevation = 0;
    protected isActive = false;
    protected openPopups: string[] = [];
    protected dialog = false;

    protected get dialogOpened() {
        return this.event.Id === +this.$route.query.e;
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }

    protected mounted() {
        if (typeof this.$route.query.openPopups === 'string') {
            this.openPopups = this.$route.query.openPopups.split(',');
            if (this.openPopups.indexOf(this.event.Id.toString()) > -1) {
                const a = this.$refs.jsPopupWrapper;
                if (a instanceof HTMLElement) {
                    a.dispatchEvent(new Event('click'));
                }
            }
        } else {
            // this.openPopups = this.$route.query.openPopups;
        }

        if (this.$route.query.e !== undefined) {
            this.dialog = this.event.Id === +this.$route.query.e;
        }
    }

    protected get event(): ICalendarData {
        return this.eventProp;
    }

    protected get startDate() {
        return this.event.StartDate
            ? this.event.StartDate.toLocaleString().slice(0, this.event.StartDate.indexOf('T'))
            : '';
    }

    protected get status() {
        return Date.parse(this.event.StartDate) < Date.now() ? 'aktywna' : 'nowa';
    }

    protected get boxHeight() {
        if (this.isMobile) {
            return this.cellHeight * 2.2;
        }

        const boxHeight = getBoxHeight(this.event, this.cellHeight);
        const fullHeight = this.cellHeight * this.aspectRatio;
        return this.isActive && boxHeight < fullHeight ? fullHeight : boxHeight;
    }

    protected getBoxColor(event: ICalendarData) {
        return getBoxColor(event);
    }

    protected getImage(url: string) {
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    protected activate() {
        this.elevation = 20;
        this.isActive = true;
    }

    protected getBoxBackColor(event: ICalendarData) {
        return getBoxBackColor(event);
    }

    protected handleClick(event: Event) {
        this.activate();
        this.$emit('openSingleActivityPopup', event);
    }

    protected subscribe() {
        this.$route.query.e = '4';
    }

    protected deactivate() {
        this.elevation = 0;
        this.isActive = false;
    }
}
